export default __webpack_public_path__ + "static/media/hangman.d2c732b3.png";